import React, { Component } from 'react'

import { Cards, Navigation, Button } from 'Components'

import Payment from 'Assets/background/background-payment.png'

export default class PaymentMethod extends Component {
	constructor(props) {
		super(props)

		this.state = {
			validations: [
				{
					id: 1,
					text: 'Gunakan format: NOKIA MPWR_PACKAGE 1/2/3_NAMA sebagai subject dari e-mail',
				},
				{
					id: 2,
					text: 'Foto atau screenshot bukti pembayaran Anda dan attach dalam e-mail',
				},
				{
					id: 3,
					text: 'Kirim email ke doofit@doogether.id',
				},
			],
		}
	}
	render() {
		const { validations } = this.state

		return (
			<div className='payment'>
				<Navigation />
				<Cards>
					<div className='payment__title'>Metode Pembayaran</div>
					<div className='payment__subtitle'>Bank Transfer</div>
					<div className='payment__desc'>BCA a/n PT. Generasi Muda Indonesia Utama No. Rek. 5244759988</div>
					<div className='payment__subtitle'>
						Validasi Pembayaran dengan E-Mail - <span>WAJIB!</span>
					</div>
					<div className='payment__validation'>
						{validations.map((validation) => {
							return (
								<div className='payment__validation__wrapper'>
									<div>{validation.id}.</div>
									<div>{validation.text}</div>
								</div>
							)
						})}
					</div>
					<div className='payment__note'>
						Ilustrasi email validasi. Note : <span>xxx hanya contoh!</span>
					</div>
					<img src={Payment} alt='payment-illustration' />
					<div className='payment__info'>
						Kode voucher akan dikirimkan ke e-mail Anda setelah bukti pembayaran diterima oleh DOOgether
					</div>
					<a
						href={`mailto:doofit@doogether.id?subject=NOKIA MPWR_PACKAGE ${
							this.props.location.query === 2 ? '1' : this.props.location.query === 4 ? '2' : '3'
						}_NAMA`}
						target='_blank'
						rel='noopener noreferrer'>
						<Button text='Kirim Bukti Transfer' />
					</a>
				</Cards>
			</div>
		)
	}
}
